'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

import { Button } from '@paction-2.0/ui';

import { captureExceptionLazy } from '@/lib/sentry/lazy';
import { logError } from '@/lib/logger';

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

/**
 * Global error boundary for the app router.
 * Matches the legacy ErrorBoundary design.
 */
export default function ErrorPage({ error, reset: _reset }: ErrorPageProps) {
  const router = useRouter();

  useEffect(() => {
    captureExceptionLazy(error);
    logError('[ErrorBoundary] Unhandled error', error, {
      digest: error.digest
    });
  }, [error]);

  return (
    <div
      style={{
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {}
      <img
        src="https://paction-shared-resources.s3.ca-central-1.amazonaws.com/common/error-image.png"
        alt="error image"
        style={{ height: '20rem', marginBottom: '1rem' }}
      />
      <h1
        style={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          marginBottom: '2rem',
          lineHeight: '2.25rem'
        }}
      >
        <span>Nobody&apos;s pawfect!</span>
        We&apos;ll get this back online soon.
      </h1>
      <Button
        onClick={() => router.back()}
        style={{ height: '3rem', width: '10rem', fontSize: '1.25rem' }}
      >
        Back
      </Button>
    </div>
  );
}
